// assets/src/jsx/util/HomeUtils.js
export const LAST_VISITED_KEY = 'gdb.lastVisitedDatabaseId';

// One display row per catalog: representative = latest non-draft version
// (falls back to latest version), recency = newest modified_at in the catalog.
export function getRecentDatabases(databaseList, limit = 5) {
    if (!Array.isArray(databaseList)) {
        return [];
    }
    const items = databaseList
        .map((catalog) => {
            const versions = (catalog.databases || []).filter((d) => !d.is_archived);
            if (!versions.length) {
                return null;
            }
            const byVersionDesc = [...versions].sort((a, b) => Number(b.version) - Number(a.version));
            const rep = byVersionDesc.find((d) => !d.is_draft) || byVersionDesc[0];
            const modifiedAt = versions.reduce(
                (max, d) => (d.modified_at > max ? d.modified_at : max),
                versions[0].modified_at
            );
            return {
                // `code` drives the canonical translated label (`db.<code>.code`),
                // matching the sidebar; `name` is the human catalog name fallback.
                id: rep.id,
                code: catalog.code,
                name: catalog.name || rep.name || catalog.code || '',
                colorHex: rep.color_hex || null,
                isDraft: !!rep.is_draft,
                modifiedAt,
            };
        })
        .filter(Boolean);
    items.sort((a, b) => {
        if (a.modifiedAt < b.modifiedAt) { return 1; }
        if (a.modifiedAt > b.modifiedAt) { return -1; }
        return 0;
    });
    return items.slice(0, limit);
}

export function isDatabaseStillPresent(databaseList, id) {
    if (!id || !Array.isArray(databaseList)) {
        return false;
    }
    return databaseList.some(
        (catalog) => (catalog.databases || []).some((d) => d.id === id && !d.is_archived && !d.is_draft)
    );
}

export function getLastVisitedDatabaseId() {
    const raw = localStorage.getItem(LAST_VISITED_KEY);
    if (!raw) {
        return null;
    }
    const id = parseInt(raw, 10);
    return Number.isNaN(id) ? null : id;
}

export function setLastVisitedDatabaseId(id) {
    if (id === null || id === undefined) {
        return;
    }
    localStorage.setItem(LAST_VISITED_KEY, String(id));
}
